// extracted by mini-css-extract-plugin
module.exports = {"preview":"Icon_preview__2uXj8"};